module.exports = __webpack_public_path__ + "static/media/5.ab2fcb95.png";